// SELECTWINE: informative EUR -> KRW conversion on product pages only.
document.addEventListener('DOMContentLoaded', () => {
  const krwBox = document.getElementById('krw-price-box');
  const krwPriceEl = document.getElementById('krwPrice');
  const krwRateEl = document.getElementById('krwRate');

  if (!krwBox || !krwPriceEl || !krwRateEl) return;

  const url = 'https://open.er-api.com/v6/latest/EUR';
  let currentRate = null;
  let currentPriceInCents = Number(krwBox.dataset.priceCents);

  const hideKrwBox = () => {
    krwBox.hidden = true;
  };

  const updateKrwPrice = (priceInCents) => {
    if (!currentRate || !Number.isFinite(priceInCents)) return;

    const krw = Math.round((priceInCents / 100) * currentRate);
    krwPriceEl.textContent = `₩${krw.toLocaleString('ko-KR')} KRW (예상가)`;
  };

  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error('Exchange-rate request failed');
      return response.json();
    })
    .then((data) => {
      const rate = Number(data.rates?.KRW);
      if (data.result !== 'success' || !Number.isFinite(rate) || rate <= 0) {
        hideKrwBox();
        return;
      }

      currentRate = rate;
      krwRateEl.textContent = `🔎 1 EUR = ${currentRate.toLocaleString('ko-KR')} KRW`;
      updateKrwPrice(currentPriceInCents);
    })
    .catch(hideKrwBox);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data?.sectionId !== krwBox.dataset.sectionId) return;
      currentPriceInCents = Number(event.data.variant?.price);
      updateKrwPrice(currentPriceInCents);
    });
  }
});
